var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer" },
    [
      _c("div", { staticClass: "customerSearch" }, [
        _c(
          "div",
          { staticClass: "search-left" },
          [
            _c(
              "el-input",
              {
                staticStyle: { width: "190px", "margin-right": "10px" },
                attrs: {
                  size: "mini",
                  placeholder: "昵称/手机号/卡号",
                  clearable: ""
                },
                on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
                model: {
                  value: _vm.formInline.queryCustomer,
                  callback: function($$v) {
                    _vm.$set(_vm.formInline, "queryCustomer", $$v)
                  },
                  expression: "formInline.queryCustomer"
                }
              },
              [
                _c("i", {
                  staticClass: "el-input__icon el-icon-search",
                  attrs: { slot: "suffix" },
                  slot: "suffix"
                })
              ]
            ),
            _c("el-date-picker", {
              staticStyle: { width: "240px", "margin-right": "10px" },
              attrs: {
                size: "mini",
                editable: false,
                type: "daterange",
                "value-format": "yyyy-MM-dd",
                "range-separator": "~",
                "start-placeholder": "添加日期",
                "end-placeholder": "添加日期"
              },
              on: { change: _vm.selectTime },
              model: {
                value: _vm.formInline.dateCustomer,
                callback: function($$v) {
                  _vm.$set(_vm.formInline, "dateCustomer", $$v)
                },
                expression: "formInline.dateCustomer"
              }
            }),
            _c(
              "el-select",
              {
                staticStyle: { width: "150px" },
                attrs: { placeholder: "请选择", size: "mini" },
                on: { change: _vm.selectBindStatus },
                model: {
                  value: _vm.formInline.bindStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.formInline, "bindStatus", $$v)
                  },
                  expression: "formInline.bindStatus"
                }
              },
              _vm._l(_vm.options, function(item) {
                return _c("el-option", {
                  key: item.bindStatus,
                  attrs: { label: item.label, value: item.bindStatus }
                })
              }),
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "search-right" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "", size: "mini" },
                on: { click: _vm.showApproveLogDialog }
              },
              [_vm._v("档案审批记录")]
            ),
            _vm.exportOption
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.handleExport }
                  },
                  [_vm._v("导出")]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "eamcTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: _vm.tableHeight
                  },
                  on: { "sort-change": _vm.sortChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: "客户",
                      "min-width": "310px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { padding: "0" },
                                        attrs: { span: 30 }
                                      },
                                      [
                                        _c("el-avatar", {
                                          directives: [
                                            {
                                              name: "image-preview",
                                              rawName: "v-image-preview"
                                            }
                                          ],
                                          attrs: {
                                            size: "medium",
                                            shape: "square",
                                            src: scope.row.avatar
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 70 } }, [
                                      scope.row.ctmName != null
                                        ? _c(
                                            "div",
                                            { staticStyle: { color: "black" } },
                                            [_vm._v(_vm._s(scope.row.ctmName))]
                                          )
                                        : _c(
                                            "div",
                                            { staticStyle: { color: "black" } },
                                            [_vm._v("无绑定职称")]
                                          ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#a09f9fc9",
                                            "font-size": "12px"
                                          }
                                        },
                                        [
                                          _vm._v(_vm._s(scope.row.name)),
                                          scope.row.type == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(70, 189, 10)"
                                                  }
                                                },
                                                [_vm._v(" @微信")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(8, 168, 231)"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " @" +
                                                      _vm._s(scope.row.corpName)
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "bindStatus",
                      label: "绑定状态",
                      "min-width": "120px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.bindStatus
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "success", size: "medium" }
                                  },
                                  [_vm._v("已绑定")]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "medium" } },
                                  [_vm._v("未绑定")]
                                )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ctmNumb",
                      label: "档案数",
                      "min-width": "100px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.ctmNumb
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ctm-numb-wrap",
                                    on: {
                                      click: function($event) {
                                        return _vm.fileDetaiDialogShow(
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "ctm-numb" }, [
                                      _vm._v(_vm._s(scope.row.ctmNumb))
                                    ]),
                                    _c("i", { staticClass: "el-icon-view" })
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "consultant",
                      label: "所属顾问",
                      "min-width": "150px"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ctmCode",
                      label: "卡号",
                      "min-width": "150px"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ctmTelephone",
                      label: "电话",
                      "min-width": "150px"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tag",
                      label: "客户标签",
                      "min-width": "250px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.tag.length > 0
                              ? _c(
                                  "div",
                                  [
                                    scope.row.tag.length == 1 &&
                                    scope.row.tag[0] == ""
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "info"
                                                }
                                              },
                                              [_vm._v("暂无标签")]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._l(scope.row.tag, function(item) {
                                      return _c(
                                        "span",
                                        { key: item },
                                        [
                                          item != "" && item != null
                                            ? _c(
                                                "el-tag",
                                                { attrs: { size: "mini" } },
                                                [_vm._v(_vm._s(item))]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _c("div", [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: { size: "mini", type: "info" }
                                        },
                                        [_vm._v("暂无标签")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "chargePerson",
                      "min-width": "100px",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "首次添加客户的员工",
                                      placement: "top-start"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v("添加人"),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-question icon-style"
                                      })
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !scope.row.addUserName
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#FFAA33" } },
                                  [_vm._v("无添加人")]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.addUserName))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "添加时间",
                      "min-width": "180px",
                      sortable: "custom"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("FileApproveLog", {
        attrs: { visiable: _vm.approveLogDialog },
        on: { closeLog: _vm.closeLog }
      }),
      _c("AllFileDetail", {
        attrs: { visiAble: _vm.fileDetaiDialog, detailItem: _vm.detailParams },
        on: { closeDetail: _vm.closeDetail }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }